import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

import { reactive, computed, watchEffect } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { FormItem } from '@/types/form';
  import { GENDER_MAP } from '@/constants';
  import { settingStore, authStore } from '@/stores';
  import _ from 'lodash';

  type Form = {
    [propName: string]: any;
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

  const { t } = useI18n();

  const form = reactive<Form>({
    phone_number: ''
  });

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  const ageOptions = computed(() => {
    const ages = [
      { text: '16-18', value: '16-18' },
      { text: '19-25', value: '19-25' },
      { text: '26-35', value: '26-35' },
      { text: '36-50', value: '36-50' },
      { text: 'Over 50', value: 'Over 50' }
    ];
    if (authStore.isB2) {
      ages.unshift({ text: 'N/A', value: 'N/A' });
    }
    return ages;
  });

  const additionalInformationFormItems = computed(() => {
    return [
      {
        label: t('AGE'),
        type: 'select',
        key: 'age',
        required: true,
        options: ageOptions.value
      },
      {
        label: t('GENDER'),
        type: 'radio',
        key: 'gender',
        required: true,
        options: _.map(GENDER_MAP, (text, value) => ({ text, value })),
      },
      {
        label: t('HOW DID YOU HEAR ABOUT US?'),
        type: 'select',
        key: 'source_channel',
        required: false,
        options: [
          { text: t('Article'), value: 'Article' },
          { text: t('Website'), value: 'Website' },
          { text: t('Friend'), value: 'Friend' },
          { text: t('Twitter'), value: 'Twitter' },
          { text: t('Facebook'), value: 'Facebook' },
          { text: t('Pinterest'), value: 'Pinterest' },
          { text: t('Instagram'), value: 'Instagram' },
          { text: t('Search'), value: 'Search' },
          { text: t('Strategic Partnerships'), value: 'Strategic Partnerships' }
        ],
      },
      {
        label: t('ORGANIZATION NAME'),
        type: 'input',
        key: 'organization_name',
        required: false,
        placeholder: t('organization_name_placeholder')
      },
      {
        label: t('ORGANIZATION TYPE'),
        type: 'select',
        key: 'organization_type',
        required: true,
        options: _.map(settingStore.data.org_type_list, item => ({ text: item, value: item })),
      },
      {
        label: t('PEOPLE COLLECTING'),
        type: 'input',
        inputType: 'number',
        min: 1,
        pattern: '[0-9]*',
        key: 'people_collection',
        required: false,
        placeholder: '200',
        slots: {
          description: {
            template: t('people_collection_description')
          }
        }
      },
    ].filter(Boolean) as FormItem[];
  });

  watchEffect(() => {
    Object.assign(form,  _.pick(_.get(authStore.user, 'profile'), additionalInformationFormItems.value.map(({ key }) => key)));
  });

  expose({
    additionalInformationFormItems
  });

return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(additionalInformationFormItems), (item) => {
    return (_openBlock(), _createBlock(_component_AppFormGroupItem, {
      key: item.key,
      config: item,
      form: _unref(form),
      onChange: formItemChange
    }, null, 8, ["config", "form"]))
  }), 128))
}
}

})